module.exports = __webpack_public_path__ + "img/cube_1.ebb1f612.svg";